// extracted by mini-css-extract-plugin
export default {"videoTitling":"user-copywriter-video-titling_videoTitling__4mKOt"};